import { render, staticRenderFns } from "./Flights.vue?vue&type=template&id=57f2c412&scoped=true&"
import script from "./Flights.vue?vue&type=script&lang=js&"
export * from "./Flights.vue?vue&type=script&lang=js&"
import style0 from "./Flights.vue?vue&type=style&index=0&id=57f2c412&prod&lang=scss&"
import style1 from "./Flights.vue?vue&type=style&index=1&id=57f2c412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f2c412",
  null
  
)

export default component.exports